import {createFeatureSelector, createSelector} from '@ngrx/store';
import {teacherFeatureKey, TeacherState} from "../reducers/teacher.reducer";

export const selectTeacherFeature = createFeatureSelector<TeacherState>(
  teacherFeatureKey
);

export const getActiveClassId = () => createSelector(
  selectTeacherFeature,
  (state: TeacherState) => {
    return state.activeClassId;
  }
);

